import { Directive, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ValidatorService } from '@capturum/ui/api';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Directive()
export class AuthPageBase implements OnInit, OnDestroy {
  public form: FormGroup;
  protected destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    protected readonly validatorService: ValidatorService,
  ) {
  }

  public ngOnInit(): void {
    this.fetchBackendErrors();
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  protected markAsTouched(): void {
    for (const key in this.form.controls) {
      if (this.form.get(key)) {
        this.form.get(key).markAsTouched();
      }
    }
  }

  private fetchBackendErrors(): void {
    this.validatorService?.backendValidation$
      .pipe(takeUntil(this.destroy$), filter(Boolean))
      .subscribe((errors: Record<string, string[]>) => {
        this.validatorService.setBackendErrorsOnForm(this.form, errors);
      });
  }
}
